<template>
  <div>
    <div class="tw-mb-5">
      <WdsHeading as="h1" type="display">
        {{ $t('Compliance settings') }}
      </WdsHeading>
    </div>
    <div v-if="loading" class="tw-p-4">
      <WdsSpinner indeterminate :size="40" />
    </div>
    <template v-else>
      <FeatureFlagged name="compliance-table">
        <ComplianceTrackerSettingsForm />
        <WdsDivider class="tw-my-8" />
      </FeatureFlagged>
      <ComplianceSettingsPage :company="activeAccount" :compliances="compliances" :errors="errors" />
    </template>
  </div>
</template>

<script setup>
import { useQuery } from '@vue/apollo-composable'
import { WdsDivider, WdsHeading, WdsSpinner } from '@worksome/wds-components'
import gql from 'graphql-tag'
import { computed } from 'vue'
import { ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT } from '@/components/compliances/queries/Compliances'
import ComplianceSettingsPage from '@/components/compliances/settings/ComplianceSettingsPage.vue'
import ComplianceTrackerSettingsForm from '@/components/compliances/settings/ComplianceTrackerSettingsForm.vue'
import FeatureFlagged from '@/components/FeatureFlagged.vue'
import { ParseJSONPropertyInObject } from '@/utils/ParseJSONPropertyInObject'

const complianceNames = [
  'EMPLOYMENT_COST',
  'IR35_COMPANY_SETTINGS',
  'UK_SOLE_TRADER',
  'UK_STATEMENT_OF_WORK',
]

const { result, loading, error } = useQuery(
  gql`
    query accountQuery($complianceNames: [ComplianceName!]!) {
      me {
        activeAccount {
          __typename
          ...ActiveCompliancesOnAccount
        }
      }
    }
    ${ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT}
  `,
  {
    complianceNames,
  },
)

const activeAccount = computed(() => result?.value?.me?.activeAccount)

const compliances = computed(
  () =>
    activeAccount.value?.compliances
      ?.filter((compliance) => compliance.isApplicable)
      ?.map((compliance) => ParseJSONPropertyInObject('data', compliance)) || [],
)

const errors = computed(() => error.value?.graphQLErrors)
</script>
